<template>
 <div class="stream">
   <video autoplay playsinline loop id="myVideo">
     <source :src="require('../assets/' + streamInfo.src)" type="video/mp4">
   </video>
   <div class="stream-top">
     <div class="stream-info-container">
       <div class="profile-picture">
         <div class="live">LIVE</div>
       </div>
       <div class="profile-information-container">
         <div class="profile-information">
           <span class="username">Ashley</span>
           <span class="followers">1k Zuschauer</span>
         </div>
         <div class="follow">Folgen</div>
       </div>
     </div>
     <span class="close" @click="closeStream()">x</span>
   </div>
   <div class="stream-bottom">
     <div ref="chatHistory" class="chat-history">
       <div v-for="item in chatMessages" :class="item.type"><div v-if="item.type === 'donation'" class="gift"></div><span>{{item.user}}</span><span>{{item.content}}</span></div>
     </div>
     <div class="stream-inputs-container">
       <input v-model="message" class="input-field" placeholder="Kommentar hinzufügen...."  v-on:keyup.enter="sendMessage">
       <div class="gift-option stream-options"></div>
       <div class="lock-option stream-options"></div>
       <div class="more-option stream-options">
         <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="9vw" height="9vw"
              viewBox="0 0 172 130"
              style=" fill:#000000;"><defs><linearGradient x1="85.98986" y1="21.49454" x2="85.9924" y2="150.50293" gradientUnits="userSpaceOnUse" id="color-1_K0l4dwcsMaJa_gr1"><stop offset="0" stop-color="#ffffff"></stop><stop offset="1" stop-color="#ffffff"></stop></linearGradient></defs><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="url(#color-1_K0l4dwcsMaJa_gr1)"><path d="M107.5,103.91667h39.41667c1.97902,0 3.58333,-1.60431 3.58333,-3.58333v-28.66667c0,-1.97902 -1.60431,-3.58333 -3.58333,-3.58333h-39.41667c-1.97902,0 -3.58333,-1.60431 -3.58333,-3.58333v-39.41667c0,-1.97902 -1.60431,-3.58333 -3.58333,-3.58333h-28.66667c-1.97902,0 -3.58333,1.60431 -3.58333,3.58333v39.41667c0,1.97902 -1.60431,3.58333 -3.58333,3.58333h-39.41667c-1.97902,0 -3.58333,1.60431 -3.58333,3.58333v28.66667c0,1.97902 1.60431,3.58333 3.58333,3.58333h39.41667c1.97902,0 3.58333,1.60431 3.58333,3.58333v39.41667c0,1.97902 1.60431,3.58333 3.58333,3.58333h28.66667c1.97902,0 3.58333,-1.60431 3.58333,-3.58333v-39.41667c0,-1.97902 1.60431,-3.58333 3.58333,-3.58333z"></path></g></g></svg>
       </div>
       <div></div>
    </div>
   </div>
 </div>
</template>

<script>
    export default {
        name: "stream",
      data: function () {
        return {
          chatMessages: [
            {user: "MrBigSpender", type: "donation", content: "1000 LC"},
            {user: "Emily Rose", type: "message", content: "Hallo meine Lieben! :)"},
            {user: "YT90", type: "message", content: "Private?"},
            {user: "Stefan_KJ", type: "message", content: "Du bist mega hübsch!"}
          ],
          streamInfo: {
            src: "StreamVideo1.mp4"
          },
          message: "",
        }
      },
      mounted() {
        let randomMessages = [
          {user: "MrBigSpender", type: "message", content: "Sexy!"},
          {user: "Emily Rose", type: "donation", content: "100 LC"},
          {user: "YT90", type: "message", content: "Du bist wunderschön!"},
          {user: "Stefan_KJ", type: "message", content: "<3"},
          {user: "MrBigSpender", type: "message", content: "Wie geht's?"},
          {user: "Emily Rose", type: "message", content: "Hallo Hübsche"},
          {user: "YT90", type: "message", content: "WOW"},
          {user: "Stefan_KJ", type: "message", content: "Wunderschön"},
          {user: "MrBigSpender", type: "message", content: "OMG!"},
          {user: "Emily Rose", type: "donation", content: "500 LC"},
          {user: "YT90", type: "message", content: "Sexy"},
          {user: "Stefan_KJ", type: "message", content: ":)"},
        ]
        var counter = 0;
        var item = "";
        var timer = window.setInterval(function() {
          item = randomMessages[counter];
          this.chatMessages.push({user: item.user, type:item.type, content:item.content,});this.scrollDown();
          counter++;
          if(counter == randomMessages.length) window.clearInterval(timer);
        }.bind((this)), 2000);
      },
      methods: {
        closeStream() {
          this.$router.push('/');
        },
        sendMessage(){
          if(this.message.trim() === "")return;
          this.chatMessages.push({user: "Max24", type:"message", content:this.message,})
          this.scrollDown();
          this.message = "";
          $("input").blur();
        },
        scrollDown(){
          var timer = window.setInterval(function() {
            try {
              let obj = this.$refs.chatHistory;
              obj.scrollTop = obj.scrollHeight;
              window.clearInterval(timer);
            } catch (error) {
              window.clearInterval(timer);
            }
          }.bind((this)), 100);
        }
      }
    }
</script>

<style scoped>
  * {
    font-family: "Helvetica";
  }
  *:focus {
    outline: none;
  }

  ::-webkit-input-placeholder {
    text-align: center;
    color: white;
    opacity: 0.7;
    font-size: 3.5vw;
  }

  :-moz-placeholder { /* Firefox 18- */
    text-align: center;
    color: white;
    opacity: 0.7;
    font-size: 3.5vw;
  }

  ::-moz-placeholder {  /* Firefox 19+ */
    text-align: center;
    color: white;
    opacity: 0.7;
    font-size: 3.5vw;
  }

  :-ms-input-placeholder {
    text-align: center;
    color: white;
    opacity: 0.7;
    font-size: 3.5vw;
  }

  .stream{
    position: fixed;
    width: 100%;
    min-height: 100%;
    left: 0;
    top: 0;
  }
  #myVideo {
    object-fit: fill;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    width: 100%;
    min-height: 100%;
    overflow: hidden;
    z-index: -1;
  }
  .stream-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10%;
    margin-right: 5vw;
  }
  .close{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10vw;
    height: 10vw;
    font-size: 6.5vw;
    background-color: rgba(0,0,0,.35);
    border-radius: 50%;
    color: rgba(255,255,255,0.8);
  }
  .stream-info-container{
    display: flex;
    align-items: center;
    width: 90vw;
    height: 20vw;
  }
  .profile-picture{
    background-image: url("../assets/profile2.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-color: white;
    height: 20vw;
    width: 20vw;
    border-radius: 50%;
    border: 4px solid #C7636F;
    margin-left: 10px;
    z-index: 10;
  }
  .live{
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    height: 7vw;
    width: 14vw;
    background-color: #C7636F;
    margin-bottom: -10px;
    border-radius: 2vw 2vw 2vw 2vw;
    font-size: 4.5vw;
  }
  .profile-information-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: -5vw;
    width: 50vw;
    height: 14vw;
    border-radius: 0vw 10vw 10vw 0vw;
    background-color: rgba(0,0,0,.35);
  }
  .profile-information{
    margin-left: 7vw;
    color: white;
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
  }
  .username{
    margin-bottom: 3px;
    font-size: 4vw;
    font-weight: bold;
  }
  .followers{
    font-size: 2.8vw;
  }
  .follow{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #C7636F;
    box-sizing: border-box;
    height: 80%;
    width:40%;
    background-color: white;
    margin-right: 5px;
    border-radius: 8vw 8vw 8vw 8vw;
    font-size: 4vw;
  }
  .stream-bottom{
    position: absolute;
    bottom: 0;
    height: 35%;
    width: 100%;
  }
  .chat-history{
    box-sizing:border-box;
    padding-left: 10px;
    height: 75%;
    width: 57%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
  }
  .chat-history > div{
    box-sizing:border-box;
    min-height: 20%;
    width: 100%;
    margin: 0 0 5% 0;
  }
  .donation{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10vw;
    background-color: rgba(0,0,0,0.35);
    color: rgba(255,255,255,0.8);
    font-size: 4vw;
    padding: 0px 10px;
  }
  .gift{
    height: 20px;
    width: 20px;
    background-image: url("../assets/gift-icon.png");
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .message{
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    color: rgba(255,255,255,0.8);
  }
  .message span:first-child{
    color:black;
    font-weight: bold;
  }
  .stream-inputs-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 25%;
  }
  .stream-options{
    border-radius: 50%;
    width: 12vw;
    height: 12vw;
    background-color: rgba(0,0,0,0.35);
  }
  .input-field{
    margin-left: 5px;
    width: 57%;
    height: 11vw;
    box-sizing:border-box;
    border-radius: 10vw;
    background-color: rgba(0,0,0,0.35);
    border: 0px;
    padding-left: 3vw;
    color: white;
  }

  .gift-option{
    background-image: url("../assets/gift-icon.png");
    background-repeat: no-repeat;
    background-size: 50%;
    background-position-y: center;
    background-position-x: center;
  }

  .more-option svg{
    display: block;
    margin: 0 auto;
  }
  .lock-option{
    background-image: url("../assets/lock-icon.png");
    background-repeat: no-repeat;
    background-size: 50%;
    background-position-y: center;
    background-position-x: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Stream.vue